import Dropdown from "./Dropdown"
import DropdownItemNoHover from "./DropdownItemNoHover"
import DropdownItem from "./DropdownItem"
import Link from "next/link"
import { IoMdApps } from "react-icons/io"
import { TbSwitchHorizontal } from "react-icons/tb";
import { FaCaretRight } from "react-icons/fa";

import { useState, useEffect } from "react"
import { useRouter } from "next/navigation"
import { getAllProjects, getActiveProject, setProjectInactive, setActiveProject } from '@/utils/all_apis/project';

const ProjectsDropdown = () => {
  // const [userProjects, setUserProjects] = useState([]);
  const [memberProjects, setMemberProjects] = useState([]);
  const [activeProjectId, setActiveProjectId] = useState(null);
  const router = useRouter();

  const handleOpenProjects = async () => {
    router.push('/all-projects');
  };

  const fetchProjects = async () => {
    const memberProjs = await getAllProjects();
    // console.log(userProjs)
    // setUserProjects(userProjs);
    setMemberProjects(memberProjs);
  };

  const fetchActiveProject = async () => {
    const activeProject = await getActiveProject();
    setActiveProjectId(activeProject?.id || null);
  };

  const exitActiveProject = async () => {
    await setProjectInactive()
    window.location.href = '/';
  }

  const handleSetActiveProject = async (projectId:string) => {
    await setActiveProject(projectId)
    window.location.href = '/';
  }

  useEffect(() => {
    fetchProjects();
    fetchActiveProject();
  }, []);

  const activeProjectObj:any = memberProjects.find((project:any)=>project.id === activeProjectId)
  const activeProjectTitle = activeProjectObj?.title

  return (
    <>
      <Dropdown
          isRightAligned={true}
          trigger={
            <IoMdApps size={24} onClick={fetchProjects} />
          }
      >
        <DropdownItem onClick={()=>alert("disabled")}>
          <div className="flex items-center gap-2 text-gray-500 text-sm font-semibold font-sans">
            Apps
          </div>
        </DropdownItem>
        <DropdownItem>
          <Link href="/"><div className="flex items-center gap-2 text-gray-400 font-sm pl-4">
            InfraQ
          </div></Link>
        </DropdownItem>
        <DropdownItem onClick={handleOpenProjects}>
          <div className="flex items-center gap-2 text-gray-500 text-sm font-semibold font-sans">
            Projects  {activeProjectId&&<span className="text-xs flex items-center p-1 border font-base">Current <FaCaretRight size={14} />{activeProjectTitle}</span>}
          </div>
        </DropdownItem>
        {/* {userProjects.length > 0 && (
          <DropdownItemNoHover>
            <div className="flex flex-col gap-2 text-gray-500 text-sm font-semibold font-sans">
              <div className="font-bold hover:bg-gray-100">Your Projects</div>
              {userProjects.map((project:any) => (
                <Link key={project.id} href={`/project?id=${project.id}`} className={`pl-4 hover:bg-gray-100 ${project.id === activeProjectId ? 'font-bold' : ''}`}>
                    {project.title}
                </Link>
              ))}
            </div>
          </DropdownItemNoHover>
        )} */}
        {/* {memberProjects.length > 0 && ( */}
          <DropdownItemNoHover>
            <div className="flex flex-col gap-2 text-gray-500 text-sm font-semibold font-sans">
              {/* <div className="font-bold hover:bg-gray-100">Member Projects</div> */}
              <div key={'home'} onClick={activeProjectId?exitActiveProject:undefined} className={`pl-4 text-left flex items-center ${!activeProjectId ? 'font-bold' : ' hover:bg-gray-100'}`}>
                {activeProjectId && <><TbSwitchHorizontal size={14} />&nbsp;</>}Home
              </div>
              {memberProjects.map((project:any) => (
                <div key={project.id} onClick={project.id === activeProjectId ?undefined:()=>handleSetActiveProject(project.id)} className={`pl-4 text-left flex items-center ${project.id === activeProjectId ? 'font-bold' : ' hover:bg-gray-100'}`}>
                    {project.id === activeProjectId ? <></>:<><TbSwitchHorizontal size={14} />&nbsp;</>}{project.title}
                </div>
              ))}
            </div>
          </DropdownItemNoHover>
        {/* )} */}
      </Dropdown>
    </>
  )
}

export default ProjectsDropdown